import { useMerchant } from '@src/containers/App/MerchantProvider'
import { isMedicalServiceCategory } from '@src/types/Constants'

/** i18next context suffix for borrower-facing wording: "patient" for medical merchants, "client" otherwise. */
export type BorrowerContext = 'patient' | 'client'

/** Resolves the borrower wording from the session merchant. Requires `<MerchantProvider>` — dialog content renders outside it, so read this in the page and pass the value down. */
export const useBorrowerContext = (): BorrowerContext =>
  isMedicalServiceCategory(useMerchant().serviceCategory) ? 'patient' : 'client'
